import React from "react"
import ReactDOM from "react-dom/client"
import "./index.css"
import App from "./pages/App"
import { ToastContainer } from "react-toastify"
import { BrowserRouter as Router } from "react-router-dom"
import GlobalStyle from "./style/GlobalStyle"
import { Provider } from "react-redux"
import { store } from "./utils/store"
import "react-toastify/dist/ReactToastify.css"
import "bootstrap/dist/css/bootstrap.min.css"

const container = document.getElementById("root") as HTMLElement
const root = ReactDOM.createRoot(container)
root.render(
  <Provider store={store}>
    <React.StrictMode>
      <Router>
        <GlobalStyle />
        <App />
        <ToastContainer />
      </Router>
    </React.StrictMode>
  </Provider>
)
